import axios from '../../axios'
import {
  GET_PROMO_LIST, GET_REMINDER_LIST, GET_BIRTHDAY_LIST, GET_CLIENT_LIST, GET_GROUP_LIST, GET_BIRTHDAY_DETAIL,
  ADD_PROMOTION, UPDATE_REMINDER, UPDATE_BIRTHDAY, UPDATE_CLIENT, GET_PROMO_LIST_EXPIRED, GET_PROMOTION_DETAIL, GET_REMINDER_DETAIL, CHECK_LIMIT_PROMOTION, CHECK_OPT_OUT_REQUIRED, SEND_TEST,
  GET_CAMPAIGN_HISTORY_LIST } from './promoListTypes'
import {
  URL_GET_PROMO_LIST, URL_GET_PROMO_LIST_EXPIRED, URL_GET_REMINDER_LIST, URL_GET_BIRTHDAY_LIST, URL_GET_CLIENT_LIST, URL_GET_GROUP_LIST,
  URL_ADD_PROMOTION, URL_UPDATE_REMINDER, URL_UPDATE_BIRTHDAY, URL_UPDATE_CLIENT, URL_GET_PROMOTION_DETAIL, URL_GET_REMINDER_DETAIL, URL_GET_BIRTHDAY_DETAIL, URL_CHECK_LIMIT_PROMOTION, URL_CHECK_OPT_OUT_REQUIRED, URL_SEND_TEST,
  URL_GET_CAMPAIGN_HISTORY_LIST } from './promoListUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
export default {
  [GET_PROMO_LIST]({ commit }, item) {
    let param = new URLSearchParams({ page: item.page, 'per-page': item['per-page'] }).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_PROMO_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_PROMO_LIST, data);
              resolve(data);
            } else {
              commit(GET_PROMO_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_PROMO_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result !== null) {
          //   commit(GET_PROMO_LIST, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_PROMOTION_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_PROMOTION_DETAIL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_PROMOTION_DETAIL, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.result !== null) {
          //   commit(GET_PROMOTION_DETAIL, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_PROMO_LIST_EXPIRED]({ commit }, item) {
    let param = new URLSearchParams({ page: item.page, 'per-page': item['per-page'] }).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_PROMO_LIST_EXPIRED}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_PROMO_LIST_EXPIRED, data);
              resolve(data);
            } else {
              commit(GET_PROMO_LIST_EXPIRED, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_PROMO_LIST_EXPIRED, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result !== null) {
          //   commit(GET_PROMO_LIST_EXPIRED, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line
  [CHECK_LIMIT_PROMOTION]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_CHECK_LIMIT_PROMOTION}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_REMINDER_LIST]({ commit }, item) {
    let param = new URLSearchParams({ page: item.page, 'per-page': item['per-page'] }).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_REMINDER_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_REMINDER_LIST, data);
              resolve(data);
            } else {
              commit(GET_REMINDER_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_REMINDER_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result !== null) {
          //   commit(GET_REMINDER_LIST, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_REMINDER_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_REMINDER_DETAIL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_REMINDER_DETAIL, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.result !== null) {
          //   commit(GET_REMINDER_DETAIL, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_BIRTHDAY_LIST]({ commit }, item) {
    let param = new URLSearchParams({ page: item.page, 'per-page': item['per-page'] }).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_BIRTHDAY_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_BIRTHDAY_LIST, data);
              resolve(data);
            } else {
              commit(GET_BIRTHDAY_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_BIRTHDAY_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result !== null) {
          //   commit(GET_BIRTHDAY_LIST, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_BIRTHDAY_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_BIRTHDAY_DETAIL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_BIRTHDAY_DETAIL, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.result !== null) {
          //   commit(GET_BIRTHDAY_DETAIL, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_CLIENT_LIST]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CLIENT_LIST}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CLIENT_LIST, data);
              resolve(data);
            } else {
              commit(GET_CLIENT_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_CLIENT_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result !== null) {
          //   commit(GET_CLIENT_LIST, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },
  [GET_GROUP_LIST]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_GROUP_LIST}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_GROUP_LIST, data);
              resolve(data);
            } else {
              commit(GET_GROUP_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            GET_GROUP_LIST
            commit(GET_GROUP_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // commit(GET_GROUP_LIST, response.data.result.data)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_REMINDER]({ dispatch }, item) {
    // let param = new URLSearchParams({id:item.id}).toString();
    var bodyFormData = new FormData();
    for (var key in item) {
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_REMINDER}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_REMINDER_LIST, item);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // dispatch("GET_REMINDER_LIST", item)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_BIRTHDAY]({ dispatch }, item) {
    let param = new URLSearchParams({ id: item.id }).toString();
    var bodyFormData = new FormData();
    for (var key in item) {
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_BIRTHDAY}${param}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_BIRTHDAY_LIST, item);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // dispatch("GET_BIRTHDAY_LIST", item)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_CLIENT]({ dispatch }, item) {
    var bodyFormData = new FormData();
    for (var key in item) {
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_CLIENT}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_CLIENT_LIST, item);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // dispatch("GET_CLIENT_LIST", item)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  [ADD_PROMOTION]({ dispatch }, item) {
    var bodyFormData = new FormData();
    for (var key in item) {
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_ADD_PROMOTION}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_PROMO_LIST, item);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // dispatch("GET_PROMO_LIST", item)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line
  [CHECK_OPT_OUT_REQUIRED]() {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_CHECK_OPT_OUT_REQUIRED}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [SEND_TEST]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(URL_SEND_TEST, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_CAMPAIGN_HISTORY_LIST]({ commit }, item) {
    // let param = new URLSearchParams({ page: item.page, 'per-page': item['per-page'] }).toString();
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CAMPAIGN_HISTORY_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CAMPAIGN_HISTORY_LIST, data);
              resolve(data);
            } else {
              commit(GET_CAMPAIGN_HISTORY_LIST, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(GET_CAMPAIGN_HISTORY_LIST, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
          // if(response.data.result !== null) {
          //   commit(GET_PROMO_LIST, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },
}
